export function getSubscriberSubdomainHeader() {
  const host = window.location.hostname.toLowerCase();
  const isSubscriberHost =
    host.endsWith(".agentbookcrm.com") &&
    host !== "agentbookcrm.com" &&
    host !== "www.agentbookcrm.com" &&
    !host.startsWith("app.");

  return isSubscriberHost
    ? { "x-subscriber-subdomain": host.split(".")[0] }
    : {};
}

export function buildAuthHeaders(token, extraHeaders = {}) {
  return {
    Authorization: `Bearer ${token}`,
    ...getSubscriberSubdomainHeader(),
    ...extraHeaders
  };
}

export function buildJsonAuthHeaders(token, extraHeaders = {}) {
  return buildAuthHeaders(token, {
    "Content-Type": "application/json",
    ...extraHeaders
  });
}